import { Quotation } from './quotation';
export class Currency {
    id: number;
    name: string;
    symbol: string;
    quotationList?: Quotation[];
}